export const fcaTimelineData = [
  {
    id: 'jul-2026-guidance',
    date: 'July 2026',
    headline: 'Scheme partially suspended',
    description:
      'The FCA continues to progress the motor finance compensation scheme. Despite ongoing legal challenges, lenders are continuing to prepare eligible claims.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/statements/motor-finance-scheme-partially-suspended',
      },
    ],
  },
  {
    id: 'jun-2026-guidance',
    date: 'June 2026',
    headline: 'Further FCA guidance issued',
    description:
      'FCA issues document providing further information for firms on various aspects of the compensation scheme.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/firms/information-firms-motor-finance-complaints#section-more-information',
      },
    ],
  },
  {
    id: 'may-2026-expectations',
    date: 'May 2026',
    headline: 'FCA sets expectations',
    description:
      'FCA publishes a statement setting out their expectations following the challenge.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/statements/legal-challenges-motor-finance-compensation-scheme-update-firms-consumers',
      },
    ],
  },
  {
    id: 'may-2026-legal-challenges',
    date: 'May 2026',
    headline: 'Legal challenges confirmed',
    description:
      "FCA's redress scheme faces legal challenge at the Upper Tribunal. The FCA states it will defend the scheme robustly.",
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/statements/fca-statement-legal-challenges-motor-finance-scheme',
      },
    ],
  },
  {
    id: 'mar-2026-redress-scheme',
    date: 'March 2026',
    headline: 'Final redress scheme published',
    description:
      'FCA publishes final redress rules (PS26/3). Scheme covers 12.1 million agreements made between April 2007 and November 2024. Average redress is estimated at £829 per agreement, with the scheme expected to return £7.5 billion to consumers.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/publications/policy-statements/ps26-3-motor-finance-consumer-redress-scheme',
      },
      {
        label: 'Read on kpmg.com',
        url: 'https://kpmg.com/xx/en/our-insights/regulatory-insights/motor-finance-latest-updates.html',
      },
    ],
  },
  {
    id: 'dec-2025-complaint-pause-extended',
    date: 'December 2025',
    headline: 'Complaint pause extended',
    description:
      'FCA further extends the time firms have to send final responses to all DCA and non-DCA complaints.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/publication/policy/ps25-18.pdf',
      },
    ],
  },
  {
    id: 'oct-2025-consultation-paper',
    date: 'October 2025',
    headline: 'Redress scheme consultation paper',
    description:
      'FCA publishes consultation paper CP25/27 on a proposed industry-wide motor finance consumer redress scheme, initially estimating £8.2 billion to be paid out on around 14 million agreements.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/publications/consultation-papers/cp25-27-motor-finance-consumer-redress-scheme',
      },
      {
        label: 'Read on hlc.com',
        url: 'https://www.hlc.com/en/publications/the-road-to-redress-fcas-motor-finance-commission-consultation-explained',
      },
    ],
  },
  {
    id: 'aug-2025-supreme-court-judgement',
    date: 'August 2025',
    headline: 'Supreme court judgement',
    description:
      'Supreme Court partially overturns the Court of Appeal decision. Rules that hidden commission alone does not make an arrangement unfair but finds in favour of one claimant (Johnson) due to the scale of undisclosed commission and misleading documentation.',
    links: [
      {
        label: 'Read on supremecourt.uk',
        url: 'https://supremecourt.uk/cases/press-summary/uksc-2024-0159',
      },
      {
        label: 'Read on exchangechambers.co.uk',
        url: 'https://www.exchangechambers.co.uk/supreme-court-clarifies-law-on-commission-payments-in-car-finance-cases-hopcraft-johnson-and-wrench-2025-uksc-33/',
      },
    ],
  },
  {
    id: 'dec-2024-appeal-granted',
    date: 'December 2024',
    headline: 'Supreme court appeal granted',
    description:
      'Supreme Court grants Permission to Appeal in all three cases from the October Court of Appeal judgment. Hearing dates confirmed as 1–3 April 2025.',
    links: [
      {
        label: 'Read on mayerbrown.com',
        url: 'https://www.mayerbrown.com/en/insights/publications/2024/12/uk-supreme-court-grants-permission-to-appeal-landmark-case-on-motor-finance-commission-payments-and--disclosure-thresholds',
      },
    ],
  },
  {
    id: 'nov-2024-complaint-pause-consultation',
    date: 'November 2024',
    headline: 'Complaint pause consultation',
    description:
      'FCA announces consultation on extending its complaint-handling pause to include claims involving non-DCA commissions.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/statements/fca-consult-extending-time-motor-finance-firms-handle-commission-complaints',
      },
    ],
  },
  {
    id: 'oct-2024-court-of-appeal',
    date: 'October 2024',
    headline: 'Court of appeal judgement',
    description:
      'Landmark Court of Appeal ruling opens the door for non-DCA commission claims, sending shockwaves through the car finance sector.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/statements/court-appeal-judgment-hopcraft-johnson-wrench',
      },
      {
        label: 'Read on lawplus.co.uk',
        url: 'https://www.lawplus.co.uk/pcp/important-update-car-finance-mis-selling-claims/',
      },
    ],
  },
  {
    id: 'jan-2024-investigation-launched',
    date: 'January 2024',
    headline: 'FCA investigation launched',
    description:
      'FCA launches investigation into historical car finance mis-selling involving DCAs and pauses complaint handling for DCA-related claims.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/statements/legal-challenges-motor-finance-compensation-scheme-update-firms-consumers',
      },
      {
        label: 'Read on addleshawgoddard.com',
        url: 'https://www.addleshawgoddard.com/en/insights/insights-briefings/2024/financial-regulation/financial-regulation-in-the-know-consumer-finance/fcas-ongoing-motor-finance-commission-review-current-status/',
      },
    ],
  },
  {
    id: 'jan-2021-dca-ban-introduced',
    date: 'January 2021',
    headline: 'DCA ban introduced',
    description:
      'FCA officially bans discretionary commission arrangements (DCAs) in the motor finance market.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/press-releases/fca-ban-motor-finance-discretionary-commission-models',
      },
      {
        label: 'Read policy statement PS20/8',
        url: 'https://www.fca.org.uk/publication/policy/ps20-8.pdf',
      },
    ],
  },
  {
    id: 'oct-2019-dca-ban-consultation',
    date: 'October 2019',
    headline: 'DCA ban consultation published',
    description:
      'FCA publishes Consultation Paper CP19/28 proposing a ban on discretionary commission arrangements (DCAs), which allowed brokers to adjust interest rates to earn higher commission.',
    links: [
      {
        label: 'Read consultation paper CP19/28',
        url: 'https://www.fca.org.uk/publication/consultation/cp19-28.pdf',
      },
    ],
  },
  {
    id: 'mar-2019-final-findings',
    date: 'March 2019',
    headline: 'Final findings published',
    description:
      'FCA publishes final findings report concluding commission arrangements may be causing consumer harm on a significant scale, costing consumers over £300 million annually. It identifies widespread use of commission models linked to interest rates.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/press-releases/fca-acts-address-unclear-and-excessive-motor-finance-costs',
      },
      {
        label: 'Read the final findings report',
        url: 'https://www.fca.org.uk/publication/multi-firm-reviews/our-work-on-motor-finance-final-findings.pdf',
      },
    ],
  },
  {
    id: 'mar-2018-initial-findings',
    date: 'March 2018',
    headline: 'Initial findings published',
    description:
      'FCA publishes a 16-page paper outlining its initial findings and further work to be undertaken.',
    links: [
      {
        label: 'Read on fca.org.uk',
        url: 'https://www.fca.org.uk/news/news-stories/our-work-motor-finance',
      },
      {
        label: 'Read the initial findings paper',
        url: 'https://www.fca.org.uk/publication/research/our-work-on-motor-finance.pdf',
      },
    ],
  },
  {
    id: 'jun-2017-market-review-begins',
    date: 'June 2017',
    headline: 'FCA market review begins',
    description:
      'FCA begins its first scrutiny of the motor finance market, examining responsible lending, commission conflicts of interest, and transparency of information to consumers.',
    links: [
      {
        label: 'Read the market review findings',
        url: 'https://www.fca.org.uk/publication/multi-firm-reviews/our-work-on-motor-finance-final-findings.pdf',
      },
      {
        label: 'Read on specialistautomotivefinance.org.uk',
        url: 'https://www.specialistautomotivefinance.org.uk/resources/fca-review-of-motor-finance.html',
      },
    ],
  },
]

export default fcaTimelineData
